<template>
  <div class="database">
    <DatabaseTab
      ref="DatabaseTab"
      :menu-list="categoriesList"
      :course-category-id-first.sync="courseCategoryIdFirst"
      :course-category-id-second.sync="courseCategoryIdSecond"
      :course-category-id-third.sync="courseCategoryIdThird"
      @defaultList="defaultList"
    ></DatabaseTab>
    <DatabaseSearch
      v-model="searchValue"
      ref="searchRef"
      @onSearchEnter="onSearchEnter"
      @clearSearchValue="clearSearchValue">
    </DatabaseSearch>
    <div class="database-content">
      <div class="database-content-left">
        <DatabaseLeftMenu
          ref="DatabaseLeftMenu"
          :menu-list="categoriesList"
          :course-category-id-first.sync="courseCategoryIdFirst"
          :course-category-id-second.sync="courseCategoryIdSecond"
          :course-category-id-third.sync="courseCategoryIdThird"
          @defaultList="defaultList"
        ></DatabaseLeftMenu>
      </div>
      <div class="database-content-right">
        <van-list v-if="courseList && courseList.length > 0"
                  :loading="state && state.loading" :finished="state && state.finished"
                  :finished-text="state.finishText" @load="getCoursesList">
          <DatabaseListItem :item="item" v-for="(item, index) in courseList" :key="index"
                            :course-category-id-first="courseCategoryIdFirst"
                            :course-category-id-second="courseCategoryIdSecond"
                            :course-category-id-third="courseCategoryIdThird"
          ></DatabaseListItem>
        </van-list>
        <template v-else>
          <EmptyView v-if="state && state.showEmptyView" class="empty-list-view" title="暂无数据" :description="''"/>
        </template>
      </div>
    </div>
    <guide ref="guide" @guide-step-change="guideStepChange" @guide-finish="guideFinish"/>
  </div>
</template>

<script>
import DatabaseTab from './modules/DatabaseTab.vue'
import DatabaseSearch from './modules/DatabaseSearch.vue'
import {getCategoriesApi, getCoursesListPage} from '../../api/database'
import DatabaseLeftMenu from './modules/DatabaseLeftMenu.vue'
import EmptyView from '@/components/EmptyView.vue'
import {Toast} from 'vant'
import DatabaseListItem from './modules/DatabaseListItem.vue'
import withRouteTracking from '../../utils/withRouteTracking'
import Guide from '@/components/Guide.vue'
import {getRemindBool, postRemind} from '../../api/simulator'

const Profile = {
  components: {DatabaseListItem, DatabaseLeftMenu, DatabaseTab, DatabaseSearch, EmptyView, Guide},
  data() {
    return {
      categoriesList: [],
      courseCategoryIdFirst: '',
      courseCategoryIdSecond: '',
      courseCategoryIdThird: '',
      searchValue: '',
      courseList: [],
      state: {
        pageSize: 10,
        pageNum: 1,
        showEmptyView: true,
        loading: false,
        finished: false,
        finishText: '已经到底了',
      }
    }
  },
  async mounted() {
    if (window.sessionStorage.getItem('databaseFilter')) {
      let params = JSON.parse(window.sessionStorage.getItem('databaseFilter'))
      this.searchValue = params.dataValue
      this.courseCategoryIdFirst = params.courseCategoryIdFirst
      this.courseCategoryIdSecond = params.courseCategoryIdSecond
      this.courseCategoryIdThird = params.courseCategoryIdThird
    }
    const {courseCategoryIdFirst, courseCategoryIdSecond, courseCategoryIdThird} = this.$route.query
    if (courseCategoryIdFirst) {
      this.courseCategoryIdFirst = courseCategoryIdFirst
    }
    if (courseCategoryIdSecond) {
      this.courseCategoryIdSecond = courseCategoryIdSecond
    }
    if (courseCategoryIdThird) {
      this.courseCategoryIdThird = courseCategoryIdThird
    }
    window.sessionStorage.setItem('entrance', '11')
    await this.getCategories()
    if (!this.courseCategoryIdFirst) {
      this.courseCategoryIdFirst = this.categoriesList[0].id
    }
    this.state.pageNum = 1
    this.courseList = []
    await this.getCoursesList()
    await this.startGuide()
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    async guideStepChange(currentStep) {
      if (currentStep.step === '4') {
        this.courseCategoryIdFirst = this.categoriesList[1].id
      }
    },
    async guideFinish() {
      await postRemind(
        {
          'readType': 'NewCourseFrameworkGuide',
          'readTypeName': '新课程体系引导',
          'iepUserId': this.userInfo.id
        }
      )
      this.$router.back()
    },
    async startGuide() {
      const res = await getRemindBool({userId: this.userInfo.id, readType: 'NewCourseFrameworkGuide'})
      if (res.code === 0) {
        if (!res.data) {
          const steps = [
            {
              step: '2',
              selector: '.basics-course',
              icon: require('../../assets/images/home/guide/step2.png'),
              iconWidth: 160
            },
            {
              step: '3',
              selector: '.database-left-menu',
              icon: require('../../assets/images/home/guide/step3.png'),
              iconWidth: 198
            },
            {
              step: '4',
              selector: '.operation-course',
              icon: require('../../assets/images/home/guide/step4.png'),
              iconWidth: 160
            },
            {
              step: '5',
              selector: '.database-left-menu',
              icon: require('../../assets/images/home/guide/step5.png'),
              iconWidth: 198
            },
            {
              step: '6',
              selector: '.van-search__content',
              icon: require('../../assets/images/home/guide/step6.png'),
              iconWidth: 312
            },
          ]
          this.$refs.guide.start(steps)
          this.isShowCourseTipDialog = true
        }
      }
    },
    async defaultList() {
      this.searchValue = ''
      await this.resetAndFetchList()
    },
    async onSearchEnter() {
      await this.resetAndFetchList()
    },
    async clearSearchValue() {
      await this.resetAndFetchList()
    },
    async resetAndFetchList() {
      try {
        this.state.loading = false
        this.state.finished = false
        this.state.showEmptyView = true
        this.state.pageNum = 1
        this.courseList = []
        await this.getCoursesList()
      } catch (error) {
        console.error('获取课程列表失败:', error)
      }
    },
    async getCoursesList() {
      if (this.state.loading) return
      this.state.loading = true
      Toast.loading({message: '加载中...'})

      const params = {
        pageNum: this.state.pageNum,
        pageSize: this.state.pageSize,
        dataValue: this.searchValue,
        courseCategoryId: this.courseCategoryIdThird || this.courseCategoryIdSecond || this.courseCategoryIdFirst
      }

      try {
        const res = await getCoursesListPage(params)

        if (res.code !== 0 || !res.data || !res.data.list) {
          this.courseList = []
          this.state.finished = true
          this.state.showEmptyView = true
        } else {
          this.courseList = [...this.courseList, ...res.data.list]
          this.state.finished = res.data.total === 0 ? true : this.courseList.length >= res.data.total
          this.state.showEmptyView = this.courseList.length === 0
        }
        const databaseFilter = {
          dataValue: this.searchValue,
          courseCategoryIdFirst: this.courseCategoryIdFirst,
          courseCategoryIdSecond: this.courseCategoryIdSecond,
          courseCategoryIdThird: this.courseCategoryIdThird
        }
        window.sessionStorage.setItem('databaseFilter', JSON.stringify(databaseFilter))
        this.state.pageNum++
      } catch (e) {
        // 错误处理
        console.error('获取课程列表失败:', e)
        Toast.fail({message: '加载失败，请稍后再试'})
      } finally {
        this.state.loading = false
        Toast.clear()
      }
    },
    async getCategories() {
      try {
        const res = await getCategoriesApi()
        if (res.code === 0) {
          this.categoriesList = res.data
        }
      } catch (e) {
        throw e
      }
    }
  }
}
export default withRouteTracking(Profile)
</script>

<style scoped lang="less">
.database {
  height: 100vh;
  width: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  padding-bottom: 25px;
  box-sizing: border-box;

  .database-content {
    flex: 1;
    height: 0;
    display: flex;

    .database-content-left {
      width: 140px;
      border-right: 1px solid #F6F6F6;
      overflow-y: auto;
    }

    .database-content-right {
      flex: 1;
      overflow-y: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/database/database.vue